export default "__VITE_ASSET__CKElAm_l__"